import { T_PRIVACY_POLICY_PAGE_CONSTANTS } from './TYPES'

const HU_PRIVACY_POLICY_PAGE_CONSTANTS: T_PRIVACY_POLICY_PAGE_CONSTANTS = {
  PAGE_KICKER: 'GRIFFYREADS',
  PAGE_TITLE: 'Adatkezelési Tájékoztató',
  PAGE_CONTENT: [
    {
      TITLE: 'Bevezetés',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Az ADONIS CONSULTANCY, mint a www.griffyreads.com weboldal és a kapcsolódó GriffyReads alkalmazás (a továbbiakban: az Alkalmazás) tulajdonosa és üzemeltetője, tájékoztatja a látogatókat és a regisztrált felhasználókat az adatkezelési gyakorlatáról, a személyes adatok védelmét szolgáló technikai és szervezési intézkedésekről, valamint a felhasználók számára elérhető jogorvoslati lehetőségekről.',
            'Ezen Adatkezelési Tájékoztató ismerteti, hogy az Ön személyes adatainak gyűjtése, felhasználása és védelme milyen módon történik.',
            'Az Alkalmazásra történő regisztrációval és felhasználói fiók létrehozásával a felnőtt felhasználó kifejezett hozzájárulását adja saját személyes adatainak az ezen Adatkezelési Tájékoztatóban foglaltak szerinti kezeléséhez, valamint – adott esetben – azon gyermek személyes adatainak ezen Adatkezelési Tájékoztatóban foglaltak szerinti kezeléséhez is, akinek a nevében felhasználói fiókot (kapcsolt fiók) hoz létre.'
          ]
        }
      ]
    },
    {
      TITLE: 'Az Adatkezelő',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Az Adatkezelő az ADONIS CONSULTANCY (székhelye: Belgium, 1170 Watermael-Boitsfort, 16 avenue de l’Hermine), adószáma: BE 0553 528 124, képviseli: Ralph EL KHOURY alapító (a továbbiakban: az Adatkezelő).',
            'Az Adatkezelő a személyes adatokat az Amazon Web Services (AWS) által üzemeltetett, Európában (Írország) található szervereken tárolja és kezeli biztonságosan (eu-west-1 régió). Ennek megfelelően minden személyes adat az Európai Gazdasági Térségen (EGT) belül kerül tárolásra, és az Európai Unió adatvédelmi jogszabályai – többek között  a természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról szóló (EU) 2016/679 rendelet (GDPR) – szerinti védelemben részesül.'
          ]
        }
      ]
    },
    {
      TITLE: 'Az Adatkezelő által kezelt adatok és az adatkezelés célja',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'a)	A regisztrációkor megadott adatok:',
            'Az alkalmazás felnőttek és gyermekek számára készült (a regisztrált gyermekekre az alkalmazás „kalandorok”-ként hivatkozik; a regisztrált felnőttekre és gyermekekre együttesen: „felhasználók”-ként). A felhasználók az alkalmazáshoz egyéni felhasználói fiókon keresztül férnek hozzá.',
            ' ',
            'Csak felnőttek jogosultak a felhasználói fiók létrehozásának kezdeményezésére az alkalmazásra való regisztráció útján. A regisztráció során a felnőtt felhasználónak meg kell adnia a teljes nevét, születési dátumát, az előnyben részesített nyelvre vonatkozó választását, e-mail címét, jelszavát és felhasználónevét. A saját fiók létrehozását követően a felnőtt felhasználók további, kapcsolt fiókokat hozhatnak létre gyermekeik vagy tanulóik számára, ugyanazon adatok megadásával. A gyermek fiókjának létrehozása után a gyermek önállóan be tud jelentkezni, és hozzáférhet az alkalmazáshoz.',
            ' ',
            ' ',
            'Az adatok felhasználásának célja:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Az alkalmazás elérésének biztosítása és a bejelentkezés lehetővé tétele',
            'A felhasználói fiókok működtetése és karbantartása',
            'A felhasználói élmény személyre szabása, beleértve a karakterfejlődést és a ranglisták kezelését'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Jogalap:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'A GDPR 6. cikke (1) bekezdésének b) pontja: a szerződés teljesítéséhez szükséges adatkezelés (az alkalmazás elérésének és használatának biztosítása).',
            'A GDPR 6. cikke (1) bekezdésének f) pontja: az Adatkezelő jogos érdeke (a felhasználói fiókok működésének biztosítása és visszaélések megelőzése).',
            'A 13 év alatti gyermekek személyes adatainak kezelése szülői hozzájáruláshoz kötött, a GDPR 8. cikkével és a belga joggal összhangban. Ezt az biztosítja, hogy kizárólag felnőtt hozhat létre fiókot egy gyermek számára az alkalmazásban, és ő adja meg a szükséges személyes adatokat a gyermek nevében.'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'b)	A kvízekkel kapcsolatos adatok:',
            ' ',
            'Az olvasási szövegértés tesztelésének céljából a felnőtt felhasználók feleletválasztós kérdésekből álló kvízeket töltenek fel. Ezeket az adminisztrátor jóváhagyása után az alkalmazás tárolja, és azok minden felhasználó számára elérhetővé válnak. Az Alkalmazás tárolja a kalandor eredményeit, beleértve a megszerzett pontokat és az előrehaladást.',
            ' ',
            ' ',
            'Az adatok felhasználásának célja:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Az alkalmazás alapvető funkcióinak biztosítása (kvízkezelés és előrehaladás nyomon követése)',
            'Oktatási és interaktív célok támogatása'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Jogalap:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'A GDPR 6. cikke (1) bekezdésének b) pontja: a szerződés teljesítéséhez szükséges adatkezelés (az Alkalmazás alapfunkciójának – kvízek és előrehaladás követése – biztosítása).',
            'A GDPR 6. cikke (1) bekezdésének f) pontja: az Adatkezelő jogos érdeke (az Alkalmazás oktatási és interakciós céljainak támogatása).'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'c)	A könyvekkel kapcsolatos adatok:',
            ' ',
            'Az alkalmazás tárolja azon könyvek azonosító adatait, amelyeket a gyerekek a saját könyvtárukban meglévőként jelölnek meg, és lehetővé teszi ezen könyvek cseréjét más gyerekekkel. Ez elősegíti a fenntarthatóságot a könyvkölcsönzés ösztönzésével.',
            ' ',
            ' ',
            'Az adatok felhasználásának célja:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'A virtuális könyvtár funkció biztosítása',
            'Könyvcsere lehetőségének megteremtése és a kölcsönzés ösztönzése'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Jogalap:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'A GDPR 6. cikke (1) bekezdésének b) pontja: a szerződés teljesítéséhez szükséges adatkezelés (a könyvtár- és könyvcsere-funkció biztosítása).',
            'A GDPR 6. cikke (1) bekezdésének f) pontja: az Adatkezelő jogos érdeke (a fenntarthatóság és a társas interakció előmozdítása a könyvmegosztás révén).'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'd)	Kommunikáció:',
            ' ',
            'Az Adatkezelő statisztikai célokra információt gyűjt az e-mailekről és push értesítésekről.',
            ' ',
            ' ',
            'Az adatok felhasználásának célja:',
            ' '
          ]
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'Értesítések, eseményekről szóló információk és versenyekkel kapcsolatos üzenetek küldése',
            'Kommunikációs hatékonyság elemzése és az alkalmazás fejlesztése'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [' ', ' ', 'Jogalap:', ' ']
        },
        {
          TYPE: 'LIST',
          CONTENT: [
            'A GDPR 6. cikke (1) bekezdésének f) pontja: az Adatkezelő jogos érdeke (a kommunikáció hatékonyságának elemzése és az Alkalmazás fejlesztése).'
          ]
        },
        {
          TYPE: 'TEXT',
          CONTENT: [
            ' ',
            ' ',
            ' ',
            'e)	Fizetési adatok',
            ' ',
            'Az előfizetési díjak fizetése a PayPal-on keresztül történik. Az Adatkezelő platformján fizetési adatok nem kerülnek tárolásra.'
          ]
        }
      ]
    },
    {
      TITLE: 'Az Ön személyes adatainak megosztása',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Az Adatkezelő nem értékesíti, nem adja el, és egyéb módon sem továbbítja az Ön személyes adatait harmadik felek részére, kivéve, ha ez az alkalmazás szolgáltatásainak nyújtásához, a hatályos jogszabályi kötelezettségek teljesítéséhez, vagy jogainak védelméhez szükséges.'
          ]
        }
      ]
    },
    {
      TITLE: 'Adatbiztonság',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Az Adatkezelő megfelelő biztonsági intézkedéseket alkalmaz annak érdekében, hogy megóvja a személyes adatokat a jogosulatlan hozzáféréstől, megváltoztatástól, nyilvánosságra hozataltól vagy megsemmisítéstől.'
          ]
        }
      ]
    },
    {
      TITLE: 'Az Ön jogai',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Ön jogosult arra, hogy kérelmezze az Adatkezelőtől a személyes adataihoz való hozzáférést, azok helyesbítését vagy törlését. Ön jogosult továbbá arra, hogy tiltakozzon a személyes adatainak kezelése ellen, vagy kérheti annak korlátozását. E jogai érvényesítése érdekében kérjük, vegye fel a kapcsolatot az Adatkezelővel a contact@griffyreads.com címen.'
          ]
        }
      ]
    },
    {
      TITLE: 'Ezen Adatvédelmi Tájékoztató módosítása',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Az Adatkezelő fenntartja a jogot, hogy időről időre módosítsa ezen Adatvédelmi Tájékoztatót. Az Adatkezelő ezen Adatkezelési Tájékoztató módosításairól a módosított változat weboldalon történő közzétételével értesíti Önt. Az Alkalmazásnak az ezen Adatvédelmi Tájékoztató módosítását követő további használata a módosított Adatkezelési Tájékoztató elfogadásának minősül.'
          ]
        }
      ]
    },
    {
      TITLE: 'Kapcsolat',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Ha kérdése vagy észrevétele van ezen Adatvédelmi Tájékoztatóval kapcsolatban, kérjük, vegye fel a kapcsolatot az Adatkezelővel: contact@griffyreads.com.'
          ]
        }
      ]
    },
    {
      TITLE: 'Panasztételi jog',
      CONTENT: [
        {
          TYPE: 'TEXT',
          CONTENT: [
            'Ha megítélése szerint úgy véli, hogy személyes adatainak kezelése sérti az alkalmazandó adatvédelmi jogszabályokat, joga van panaszt tenni egy felügyeleti hatóságnál.',
            '',
            '',
            'Belgiumban az illetékes hatóság:',
            'Belgiumi Adatvédelmi Hatóság',
            'Rue de la Presse 35, 1000 Brüsszel',
            '',
            '',
            'Weboldal: https://www.dataprotectionauthority.be',
            '',
            '',
            '',
            'Hatálybalépés',
            'Ez az Adatvédelmi Szabályzat 2025. május 05. napjától hatályos.'
          ]
        }
      ]
    }
  ]
}

export default HU_PRIVACY_POLICY_PAGE_CONSTANTS
